import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { ControlRootState } from '../domains/ControlRootState';

export const useControlTypedSelector: TypedUseSelectorHook<ControlRootState> =
  useSelector;

export default useControlTypedSelector;
